{
  "_provenance": {
    "ns": "calendar",
    "source": "pages/CalendarPage.tsx, components/calendar/** and lib/calendar-display.ts (#2109 R3 lane L2)"
  },
  "add": {
    "clearPrefill": "Clear",
    "editEyebrow": "Edit appointment",
    "editTitle": "Update the details",
    "field": {
      "duration": "Duration (min)",
      "location": "Location",
      "notes": "Notes (optional)",
      "prepNotes": "Prep notes",
      "provider": "Provider",
      "type": "Type",
      "what": "What is it?",
      "when": "When"
    },
    "footer": {
      "onCalendar": "Will appear on the family calendar",
      "recordOnly": "Saved to medical record only"
    },
    "newEyebrow": "New appointment",
    "newTitle": "What’s coming up?",
    "placeholder": {
      "location": "Children’s Hospital · Infusion 4",
      "notes": "Anything {{companion}} or your circle should know",
      "prepNotes": "Bring her bag, headphones, and the soft blanket.",
      "provider": "Dr. Patel",
      "what": "e.g. Cycle 3 chemotherapy"
    },
    "prefilled": "Prefilled from your last {{type}} on {{date}}. Edit anything that’s different.",
    "submit": "Add appointment",
    "toggle": {
      "calendar": "Add to calendar",
      "prep": "Prep required",
      "transport": "Transport needed"
    }
  },
  "apptStatus": {
    "attended": "Attended",
    "cancelled": "Cancelled",
    "missed": "Missed",
    "scheduled": "Scheduled"
  },
  "apptType": {
    "chemotherapy": "Chemotherapy",
    "lab": "Lab",
    "oncology_consult": "Oncology Consult",
    "other": "Other",
    "physical_therapy": "Physical Therapy",
    "radiation": "Radiation",
    "scan": "Scan",
    "social_worker": "Social Worker",
    "surgery": "Surgery"
  },
  "callout": {
    "chemoCta": "Draft a {{nextDay}} request",
    "chemoFollowDay": "{{day}} looks heavy — chemo into a low-energy {{nextDay}}. Want me to ask your circle for {{nextDay}} backup?",
    "scanCta": "Ask the circle",
    "scanSitWith": "{{day}}’s {{title}} is at {{time}}. You may need someone with you — three helpers usually free up on weekdays.",
    "talkTo": "Talk to {{companion}}",
    "urgentCluster_one": "You have {{count}} urgent task this week still without a helper. Want me to draft a single message to the circle?",
    "urgentCluster_other": "You have {{count}} urgent tasks this week still without a helper. Want me to draft a single message to the circle?",
    "urgentPrompt_one": "Help me draft one message to my circle covering {{count}} urgent task I have this week.",
    "urgentPrompt_other": "Help me draft one message to my circle covering {{count}} urgent tasks I have this week."
  },
  "category": {
    "medical": "Medical",
    "medication": "Medication",
    "task": "Task"
  },
  "detail": {
    "backToScheduled": "Back to scheduled",
    "cancelAppointment": "Cancel appointment",
    "confirmDelete": {
      "confirm": "Delete appointment",
      "description": "This permanently removes the appointment and cannot be undone. Questions linked to it keep their own records but lose the visit tag. Cancelling instead keeps the record and can be reversed.",
      "title": "Delete {{title}}?"
    },
    "field": {
      "location": "Location",
      "notes": "Notes",
      "prep": "Prep",
      "provider": "Provider",
      "questions": "Questions",
      "status": "Status",
      "transport": "Transport",
      "type": "Type",
      "when": "When"
    },
    "kicker": "Appointment",
    "markAttended": "Mark attended",
    "pendingQuestions_one": "{{count}} pending question linked to this visit",
    "pendingQuestions_other": "{{count}} pending questions linked to this visit",
    "rideNeeded": "Ride needed",
    "unknownWhenWithDuration": "— · {{minutes}} min",
    "when": "{{weekday}} {{date}} · {{time}}",
    "whenWithDuration": "{{weekday}} {{date}} · {{time}} · {{minutes}} min"
  },
  "dose": {
    "logged": {
      "skipped": "logged skipped",
      "taken": "logged taken"
    },
    "plain": "{{dose}}",
    "withFood": "{{dose}} · with food"
  },
  "event": {
    "allDay": "All day",
    "claimedBy": "✓ {{name}}",
    "companionSuggestion": "{{companion}} suggestion",
    "needsHelper": "Needs helper",
    "until": "to {{time}}"
  },
  "filter": {
    "show": "Show"
  },
  "page": {
    "filterLabel": "Choose what the calendar shows",
    "loadError": "Couldn’t load your calendar",
    "newAppointment": "New appointment",
    "newTask": "New task",
    "searchPlaceholder": "Search this calendar",
    "toast": {
      "created": "Appointment created",
      "createdBody": "Your appointment has been added.",
      "createFailed": "Couldn’t add the appointment",
      "deleted": "Appointment deleted",
      "deletedBody": "The appointment has been removed.",
      "deleteFailed": "Couldn’t delete the appointment",
      "pleaseTryAgain": "Please try again",
      "status": {
        "attended": "Marked attended",
        "attendedBody": "The record is kept.",
        "cancelled": "Appointment cancelled",
        "cancelledBody": "You can restore it from the appointment’s details.",
        "missed": "Marked missed",
        "missedBody": "Status updated.",
        "scheduled": "Back on the schedule",
        "scheduledBody": "Status updated."
      },
      "statusFailed": "Couldn’t update the appointment status",
      "updated": "Appointment updated",
      "updatedBody": "Changes saved.",
      "updateFailed": "Couldn’t update the appointment"
    },
    "view": {
      "agenda": "Agenda",
      "month": "Month",
      "week": "Week"
    }
  },
  "suggested": {
    "dayAfter": "Day after {{title}}",
    "lowEnergy": "Likely low-energy window"
  },
  "views": {
    "addAppointment": "Add an appointment",
    "more_one": "+{{count}} more",
    "more_other": "+{{count}} more",
    "nothingScheduled": "Nothing scheduled.",
    "today": "Today"
  }
}
